import { QuarantineDetailEdit } from "./QuarantineDetailModel";

export class QuarantinePostModel {
  public RefNo?: string;
  public CustomerName?: string;
  public CustomerPo?: string;
  public Pn?: string;
  public Sn?: string;
  public Location?: string;
  public AwbNo?: string;
  public UnitType?: string;
  public IsActive?: boolean;
  public UnproperPacking?: boolean;
  public AccomplishDate?: Date;
  public QuarantineRemark?: string;
  public QuarantineReasons?: QuarantineDetailEdit[];
}

export class QuarantinePutModel {
  public Id?: number;
  public RefNo?: string;
  public CustomerName?: string;
  public CustomerPo?: string;
  public Pn?: string;
  public Sn?: string;
  public Location?: string;
  public AwbNo?: string;
  public UnitType?: string;
  public IsActive?: boolean;
  public UnproperPacking?: boolean;
  public AccomplishDate?: Date;
  public QuarantineRemark?: string;
  public QuarantineReasons?: QuarantineDetailEdit[];
}
